import { Card, Typography, List, ListItemButton, ListItemText, Tooltip } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { memo } from 'react';
import PropTypes from "prop-types";
import { cardStyle } from '../TransitionStyles';

FormList.propTypes = {
  formTitles: PropTypes.array,
  activeFormId: PropTypes.number,
  setActiveFormId: PropTypes.func
}

export default function FormList({ formTitles, activeFormId, setActiveFormId }) {
  const { formState: { isDirty } } = useFormContext();

  const handleFormClick = (formId) => {
    setActiveFormId(formId)
  };

  const tabDisabled = (formId) => isDirty && formId !== activeFormId;

  const FormNamesList = memo(() => <>
    {formTitles?.map((form) => {
      const isDisabled = tabDisabled(form.formId);
      return <Tooltip
        key={form.formName}
        placement="right"
        arrow
        title="Save changes before switching tabs"
        disableHoverListener={!isDisabled}
      >
        <span>
          <ListItemButton
            onClick={() => handleFormClick(form.formId)}
            dense
            disabled={isDisabled}
            sx={{
              wordBreak: 'break-word',
              cursor: 'pointer',
              color: form.formId === activeFormId ? 'info.main' : 'text.primary',
              textDecoration: form.formId === activeFormId ? 'underline' : 'none',
              py: 0
            }}>
            <ListItemText primary={form.formName} />
          </ListItemButton>
        </span>
      </Tooltip>
    })}
  </>);

  return <Card sx={cardStyle}>
    <Typography variant="subtitle1" color="info.main" align="center">
      Transition Forms
    </Typography>
    <List>
      <FormNamesList />
    </List>
  </Card>

}